import { Money } from '@/models/money';
import {
    OrderDTO,
    PayOrderBody,
    PostPayOrderResponse,
} from '@/models/orderTicket';
import { urlBuilder } from '../utils';
import { BackendError } from '@/models/request';
import { fetchAuthWrapper } from '@starjack/api';

export const ORDER_SERVICE = 'order';

export type PostOrdersResponseBackend = {
    ticket: OrderDTO[];
    orderId: string;
    status: string;
    identifications: [];
    shopProducts: [];
    vouchers: [];
    incertVoucherCode: null;
    location: null;
    token: null;
    total: Money;
    payAmount: Money;
    incertAmount: Money;
};

export const orderUrls = (id?: string) => ({
    orders: urlBuilder(ORDER_SERVICE, 'orders'),
    pay: urlBuilder(ORDER_SERVICE, `orders/${id}/pay`),
});

export const postOrder = async (
    body: OrderDTO
): Promise<[PostOrdersResponseBackend | null, BackendError | null]> => {
    const response = await fetchAuthWrapper(orderUrls().orders, {
        method: 'POST',
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        return [null, await response.json()];
    }

    return [await response.json(), null];
};

export const postPayOrder = async (
    body: PayOrderBody
): Promise<[PostPayOrderResponse | null, BackendError | null]> => {
    const response = await fetchAuthWrapper(orderUrls(body.orderId).pay, {
        method: 'POST',
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        return [null, await response.json()];
    }

    return [await response.json(), null];
};
